import * as React from 'react';
import * as styles from './styles.css';
export function Layout(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: styles['container']
  }, children);
}